import CollectionModel from "../models/CollectionModel";

const CollectionViewModel = {
  getCollections: async () => {
    return await CollectionModel.fetchCollections();
  },

  getCollection: async (id) => {
    return await CollectionModel.fetchCollection(id);
  },

  /**
   * Keep only the collection's images that are actually published (1..counter),
   * preserving the curated order. Unpublished numbers are gated (403) at the
   * edge, so filtering them here avoids broken tiles. A missing counter shows
   * nothing rather than a wall of 403s.
   */
  publishedImages: (images, counter) => {
    if (!Array.isArray(images)) return [];
    const max = Number.isFinite(counter) ? Math.floor(counter) : 0;
    return images.filter((n) => Number.isInteger(n) && n >= 1 && n <= max);
  },
};

export default CollectionViewModel;
